import { Outlet } from 'react-router-dom'
import StarHeader from './StarHeader'
import StarFooter from './StarFooter'

const StarLayout = () => {
  return (
    <div className="min-h-screen bg-star-cream dark:bg-gray-950 flex flex-col transition-colors">
      <StarHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <StarFooter />
    </div>
  )
}

export default StarLayout
